<template>
  <div class="container">
    <div class="main">
      <div>&nbsp;</div>
      <div class="logo-wrap">
        <div class="logo">
          <img src="static/report/logo_zyw.png" />
        </div>
        <div style="clear: both"></div>
      </div>
      <div class="sep"></div>
      <div class="title">
        <p>移宇在线报表系统</p>
      </div>

      <div class="boxContainer">
        <div class="userType">
          <p>请选择用户类型</p>
        </div>
        <!-- 医院版用户 -->
        <div class="box">
          <div class="wrap">
            <div style="height: 1px"></div>
            <p class="userTypeSelect">医院版用户</p>
            <div class="row">
              <p>我使用移宇医院版App管理患者</p>
            </div>
            <div class="btn_row">
              <div class="login-btn" @click="onBtnSelect('cgms')">
                <p>医院版报表系统</p>
              </div>
            </div>
          </div>
        </div>
        <!-- 门诊版用户 -->
        <div class="box">
          <div class="wrap">
            <div style="height: 1px"></div>
            <p class="userTypeSelect">门诊版用户</p>
            <div class="row">
              <p>我使用移宇门诊版App管理患者</p>
            </div>
            <div class="btn_row">
              <div class="login-btn" @click="onBtnSelect('report')">
                <p>门诊版报表系统</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer">
      <span>
        <a :href="contactURL"> 联系我们 </a>
        <a :href="privacyURL">| 隐私政策 </a>
        <a :href="termsOfUseURL">| 服务协议 | </a>

        ©2021 上海移宇科技有限公司 版权所有<br />
        <a target="_blank" href="http://beian.miit.gov.cn/">
          沪ICP备08013753号-3
        </a>
        <img src="/static/beian.png" />
        <a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"
        >
          沪公网安备 31011502014155号
        </a>
      </span>
    </div>
    <!--footer 结束-->
  </div>
  <!--container结束-->
</template>

<script>
// import echarts from 'echarts'
import auth from "../auth/auth";
export default {
  data() {
    return {
      contactURL: "",
      privacyURL: "",
      termsOfUseURL: "",
      username: "",
      password: "",
    };
  },
  computed: {
    // getLanguage(){
    //
    // }
  },
  watch: {
    // getLanguage(val){
    //
    // }
  },
  mounted() {},
  methods: {
    //   根据传入的系统标识跳转不同登录页面，cgms：医院版,report:门诊版
    onBtnSelect(signal) {
      if (signal === "cgms") {
        window.open("https://cgms.medtrum.cn", "_self");
      } else if (signal === "report") {
        this.$router.push("/login");
      }
    },
  },
};
</script>

<style scoped>
p,
body,
html {
  margin: 0;
}

.container {
  min-height: 800px;
  min-width: 800px;
  height: 100%;
  width: 100%;
  background-color: #0c544f;
  background-image: url("/static/report/home_bj.png");
  background-size: 100% 100%;
  /*background-size: cover;*/
  /*background-color: #000000;*/
}

.container .main {
  width: 1000px;
  margin: 0 auto;
}

.container .main .logo-wrap {
  margin-top: 100px;
}

.container .main .logo-wrap .tip {
  color: #fff;
  font-size: 36px;
  margin-top: 20px;
  float: right;
}

.container .main .logo {
  float: left;
}

.container .main .sep {
  border-bottom: 1px solid #fff;
  margin-top: 24px;
  margin-left: 70px;
  width: 351px;
}

.container .main .title {
  margin-top: 20px;
  margin-left: 70px;
  font-size: 30px;
  color: #fff;
  letter-spacing: 10px;
  font-family: Source Han Sans CN;
  /*color:#ffffff;*/
  /*font-size:36px;*/
  /*letter-spacing:200px;*/
  /*padding-bottom:11px;*/
}
.container .main .userType {
  margin-bottom: 20px;
  font-size: 30px;
  color: #fff;
  letter-spacing: 2px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  margin-left: 30px;
}
.container .main .userTypeSelect {
  font-size: 30px;
  letter-spacing: 0px;
  font-family: Source Han Sans CN;
  margin-top: 28px;
  width: 150px;
  height: 30px;
  font-weight: 500;
  color: #000000;
  /* padding-bottom: 20px; */
}

.out_link {
  /*margin:0 auto;*/
  margin-top: 30px;
}

.out_link p {
  text-align: center;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
}

.out_link p a {
  color: #fff;
  text-decoration: none;
}
.container .main .boxContainer {
  width: 1000px;
  overflow: hidden;
  margin-top: 100px;
}
.container .main .box {
  width: 440px;
  height: 276px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.47);
  /* margin-top: 40px; */
  margin: 0 30px;
  float: left;
}

.container .main .box .wrap {
  width: 90%;
  margin: 0 auto;
}

.container .main .box .wrap .row {
  margin-top: 48px;
  font-size: 24px;
  letter-spacing: 0px;
  font-weight: 400;
  font-family: Source Han Sans CN;
}

.container .main .box .wrap .row input {
  /*width: 100%;*/
  width: 350px;
  height: 40px;
  outline: none;
  border: none;
  font-size: 20px;
  padding-left: 10px;
}

.remember_pwd_row {
  /*display: table-cell;*/
  /*vertical-align: middle;*/
  margin-top: 10px;
}

.remember_pwd_row .fl {
  float: left;
}

.remember_pwd_row .c1 {
  /*height: 100%;*/
  /*display: table-cell;*/
  height: 30px;
  padding-top: 3px;
  vertical-align: middle;
}

.remember_pwd_row .c2 {
  margin-left: 5px;
}
.remember_pwd_row input {
  /*margin-top: 5px;*/
}

.remember_pwd_row span {
  line-height: 30px;
  color: #999;
}

.login-btn {
  width: 376px;
  height: 56px;
  background-color: #0c544f;
  border-radius: 30px;
  margin: 0 auto;
  cursor: pointer;
  margin-top: 68px;
}

.login-btn p {
  font-family: Source Han Sans CN;
  color: #ffffff;
  font-size: 26px;
  line-height: 56px;
  padding-bottom: 11px;
  text-align: center;
}

#remember_pwd_check {
  height: 24px;
  width: 24px;
  color: #fff;
  position: relative;
}

#remember_pwd_check:after {
  position: absolute;
  width: 21px;
  height: 21px;
  top: 1px;
  left: 1px;
  content: " ";
  background-color: #fff;
  color: #000;
  display: inline-block;
  visibility: visible;
  /*padding: 0px 3px;*/
  /*border-radius: 3px;*/
  /*padding-left:2px;*/
  text-align: center;
  line-height: 24px;
}

#remember_pwd_check:checked:after {
  content: "✓";
  font-size: 18px;
  font-weight: bold;
}

.container .main .box .wrap .img-wrap {
  display: inline-block;
  vertical-align: middle;
  /*margin-top: 5px;*/
  /*padding-top: 5px;*/
}

/*.container .main .box .wrap .img-wrap img {*/
/*  vertical-align: center;*/
/*}*/

.container .main .box .wrap img {
  /*margin-top:15px;*/
  /*padding-top: 5px;*/
  /*line-height: 40px;*/
  /*display: inline-block;*/
}
.footer::before {
  content: "";
  clear: both;
}
.footer {
  height: 21px;
  width: 80%;
  margin: 7% auto 0;
  font-size: 18px;
  color: rgba(246, 248, 251, 0.9);
  letter-spacing: -0.54px;
  text-align: center;
  font-family: SFUIText-Regular;
}
.footer a {
  color: rgba(246, 248, 251, 0.9);
  text-decoration: none;
}
.footer a:hover {
  color: #0090d3;
}
@media screen and (max-width: 1800px) {
  .footer {
    margin: 3.5% auto 0;
  }
}

@media print {
}
</style>



// WEBPACK FOOTER //
// UserTypeSelect.vue?9f56abd8